(function(root){"use strict";var stkT=root.stkT||function(k,f){return f};function stkFmt(key,fb,vars){var s=stkT(key,fb);if(vars){for(var vk in vars){if(Object.prototype.hasOwnProperty.call(vars,vk))s=s.split("{{"+vk+"}}").join(vars[vk])}}return s}var DEFAULT_API="https://stickiply-uploads-api.stickiply.workers.dev",RIGHTS_COPY=stkT("stk.lab_cart.rights_copy","I own or have the rights to print this artwork."),CART_FAIL=stkT("stk.lab_cart.cart_fail_generic","Could not add to the cart. Try again.");function plainError(e,fallback){var m=e&&e.message?String(e.message):"";var ok=m&&m.length<200&&!/[<>{}]|unexpected token|undefined|is not a function|NetworkError|Failed to fetch|SyntaxError|TypeError|ReferenceError|JSON/i.test(m);return ok?m:(fallback||CART_FAIL)}function norm(s){return String(s==null?"":s).trim().toLowerCase()}function resolveVariant(product,selections){if(!product||!product.variants||!product.variants.length)return null;selections=selections||{};for(var names=product.options||[],optNames=names.map(function(o){return typeof o=="string"?o:o&&o.name}),i=0;i<product.variants.length;i++){for(var v=product.variants[i],opts=v.options||[v.option1,v.option2,v.option3],ok=!0,n=0;n<opts.length;n++){var want=selections[optNames[n]];if((want==null||want==="")&&(want=selections[n]),!(want==null||want==="")&&norm(opts[n])!==norm(want)){ok=!1;break}}if(ok)return v}return null}function buildProperties(spec){spec=spec||{};if(spec.designs)return api.designProperties(spec);var p={};return(spec.artworkUrls||[]).forEach(function(u,i){u&&(p["Artwork Upload ("+(i+1)+")"]=u)}),spec.previewUrl&&(p._Preview=spec.previewUrl),spec.tool&&(p._tool=spec.tool),spec.designName&&(p["Design Name"]=spec.designName),spec.note&&(p.Note=spec.note),spec.extra&&Object.keys(spec.extra).forEach(function(k){var val=spec.extra[k];val!=null&&val!==""&&(p[k]=val)}),spec.hidden&&Object.keys(spec.hidden).forEach(function(k){var val=spec.hidden[k];val!=null&&val!==""&&(p[k[0]==="_"?k:"_"+k]=val)}),p}function makeUpload(apiBase,getProgress){var base=(apiBase||DEFAULT_API).replace(/\/+$/,"");return function(fieldId,blob,filename){return fetch(base+"/api/upload-url",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({fieldId:fieldId,filename:filename,contentType:blob.type,size:blob.size})}).then(function(r){if(!r.ok)throw new Error("presign "+r.status+" for '"+fieldId+"'");return r.json()}).then(function(j){return new Promise(function(res,rej){var xhr=new XMLHttpRequest;xhr.open("PUT",j.uploadUrl,!0);/* the bar is driven by the bytes that are really on the wire, not by a file counter: a 9MB print file and a 40KB cut file are not half each */try{xhr.upload.onprogress=function(ev){var cb=getProgress&&getProgress();if(cb&&ev.lengthComputable)cb({loaded:ev.loaded,total:ev.total,fieldId:fieldId})};}catch(e){}var UNSAFE=/^(content-length|host|connection|origin|referer)$/i;j.headers&&Object.keys(j.headers).forEach(function(h){UNSAFE.test(h)||xhr.setRequestHeader(h,j.headers[h])}),xhr.onload=function(){xhr.status>=200&&xhr.status<300?res(j.publicUrl):rej(new Error("upload "+xhr.status))},xhr.onerror=function(){rej(new Error("upload failed"))},xhr.send(blob)})})}}function addToCart(item){var body={items:Array.isArray(item)?item:[item]},drawer=document.querySelector("cart-drawer");return drawer&&(body.sections="cart-drawer,cart-icon-bubble",body.sections_url=window.location.pathname),fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(body)}).then(function(r){return r.text().then(function(txt){var j=null;try{j=txt?JSON.parse(txt):null}catch(e){j=null}if(!r.ok||!j){/* 6 Oct 2026: Shopify's own reason (the custom-line guard's translated message, a stock limit) is shown, not hidden behind the generic text; the raw body goes to the console */var why=j&&(j.description||j.message);try{root.console&&console.warn("[lab-cart] add refused",r.status,txt&&txt.slice(0,400))}catch(e){}throw new Error(why&&typeof why=="string"?why:CART_FAIL+" ("+r.status+")")}return j})}).then(function(res){return openCart(res),res})}function openCart(addRes){var drawer=document.querySelector("cart-drawer");/* v2.5: ONE uncaught error per successful add, measured 12 Sep: "TypeError: null is not an object (evaluating container.querySelectorAll) at getFocusableElements ... trapFocus". Root cause, read off this theme cart-drawer.js: open() does containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"). renderContents clears is-empty from .drawer__inner but NEVER from the <cart-drawer> host, so after adding to an empty cart the host still says is-empty while .drawer__inner-empty has just been replaced by the real cart - null into trapFocus. The drawer is no longer empty the instant renderContents returns, so that is where the class is cleared, before open() runs on its setTimeout. The theme is not touched. */if(drawer&&addRes&&addRes.sections&&typeof drawer.renderContents=="function")try{drawer.renderContents(addRes);try{drawer.classList.remove("is-empty");var _di=drawer.querySelector(".drawer__inner");if(_di)_di.classList.remove("is-empty")}catch(e2){}return}catch(e){}if(drawer&&typeof drawer.open=="function")try{drawer.classList.remove("is-empty");drawer.open();return}catch(e){}window.location="/cart"}function runSeq(thunks){var out=[];return thunks.reduce(function(p,t){return p.then(function(){return t().then(function(u){out.push(u)})})},Promise.resolve()).then(function(){return out})}function create(cfg){cfg=cfg||{};var inst;var upload=makeUpload(cfg.apiBase,function(){return inst&&inst.onProgress}),inst={uploadFile:upload,uploadDesign:function(o){return api.uploadDesign(upload,o)},addToCart:addToCart,resolveVariant:function(sel){return resolveVariant(cfg.product,sel)},buildProperties:function(s){return buildProperties(cfg.unit&&s&&s.unit==null?Object.assign({unit:cfg.unit},s):s)},checkout:function(c){c=c||{};var status=c.onStatus||function(){};if(c.requireRights&&!c.rightsChecked){var er=new Error(stkT("stk.lab_cart.err_rights_required","Please tick the box to confirm you have the rights to this artwork."));return status(er.message,"error"),Promise.reject(er)}var variant=resolveVariant(cfg.product,c.selections||{});if(!variant){var ev=new Error(stkT("stk.lab_cart.err_variant_unavailable","Sorry, that combination is not available. Please pick another option."));return status(ev.message,"error"),Promise.reject(ev)}if(variant.available===!1){var ea=new Error(stkT("stk.lab_cart.err_sold_out","That option is sold out right now."));return status(ea.message,"error"),Promise.reject(ea)}if(c.designs)return status(stkT("stk.lab_cart.status_uploading","Uploading your artwork\u2026"),"busy"),api.uploadDesigns(inst,c.designs,c.designFieldId||cfg.designFieldId).then(function(designs){var props=buildProperties({tool:cfg.tool,designs:designs,note:c.note,extra:c.extra,hidden:c.hidden});return status(stkT("stk.lab_cart.status_adding","Adding to your cart\u2026"),"busy"),addToCart({id:variant.id,quantity:c.quantity||1,properties:props})}).then(function(res){return status(stkT("stk.lab_cart.status_added","Added to cart \u2713"),"done"),res}).catch(function(err){throw status(plainError(err),"error"),err});var files=(c.files||[]).filter(function(f){return f&&f.blob});if(!files.length){var ef=new Error(stkT("stk.lab_cart.err_no_files","Nothing to send. Add a design first."));return status(ef.message,"error"),Promise.reject(ef)}return status(stkT("stk.lab_cart.status_uploading","Uploading your artwork\u2026"),"busy"),runSeq(files.map(function(f){return function(){return upload(f.fieldId,f.blob,f.filename)}})).then(function(urls){for(var _i=0;_i<urls.length;_i++)if(!urls[_i])throw new Error(stkT("stk.lab_cart.err_upload_incomplete","Your artwork did not finish uploading. Please try again."));var artworkUrls=[],_hid={};c.hidden&&Object.keys(c.hidden).forEach(function(k){_hid[k]=c.hidden[k]});files.forEach(function(f,i){f.property?_hid[f.property]=urls[i]:artworkUrls.push(urls[i])});var previewP=c.preview&&c.preview.blob?upload(cfg.previewFieldId||"lab-preview",c.preview.blob,c.preview.filename||(cfg.tool||"lab")+"-preview.jpg").catch(function(e){return root.console&&console.warn("[lab-cart] preview upload skipped:",e&&e.message),null}):Promise.resolve(null);return previewP.then(function(previewUrl){var props=buildProperties({tool:cfg.tool,artworkUrls:artworkUrls,previewUrl:previewUrl,designName:c.designName,note:c.note,extra:c.extra,hidden:_hid});return status(stkT("stk.lab_cart.status_adding","Adding to your cart\u2026"),"busy"),addToCart({id:variant.id,quantity:c.quantity||1,properties:props})})}).then(function(res){return status(stkT("stk.lab_cart.status_added","Added to cart \u2713"),"done"),res}).catch(function(err){throw status(plainError(err),"error"),err})}};return inst}var api={create:create,resolveVariant:resolveVariant,buildProperties:buildProperties,addToCart:addToCart,plainError:plainError,RIGHTS_COPY:RIGHTS_COPY,CART_FAIL:CART_FAIL,DEFAULT_API:DEFAULT_API};typeof module!="undefined"&&module.exports&&(module.exports=api),root.LabCart=api})(typeof window!="undefined"?window:globalThis);
/* sticker lane 12 Sep: files[].property routes an upload to a hidden property (cut SVG -> _cut) and an empty publicUrl aborts before /cart/add.js. Patched onto the minified build already on the theme, so the sourcemap below is stale for checkout(). */
/* P158 24 Sep 2026: three hooks on line 1, nothing else there changed. buildProperties({designs}) returns LabCart.designProperties(spec), instances gain uploadDesign(), and checkout({designs}) uploads ONE zip per design through LabCart.uploadDesigns. All three live in the "LabCart v2" block at the foot of this file. The artworkUrls, previewUrl and files[].property paths are untouched for any caller that still sends them. */

/* ==========================================================================
   LabCart.picker - THE PRODUCT PAGE'S OWN VARIANT PICKER, INSIDE THE LAB.

   Thomas, 12 Sep 2026, looking at the Proof Lab opened from Custom Vinyl
   Stickers: "on add to cart via labs... this doesnt look anything like...
   this." The lab drew its own chips and its own small price; the page beside
   it drew the row-list picker. One shop, two pickers.

   SO THIS RENDERS THE PAGE'S PICKER. Same markup, same class names, same
   stylesheet: .vpick-group--card / .vpick / .cgrid / .vrows / .vrow, straight
   out of snippets/product-variant-picker.liquid, product-variant-chipgrid
   .liquid and product-variant-rows.liquid, painted by assets/variant-rows.css.

   WHY IT IS A JS PORT AND NOT `{% render %}`.
   Two reasons, both measured:
     1. Every lab lives in a SHADOW ROOT. A Liquid snippet rendered into the
        page cannot be moved into a shadow tree and keep its styling, and the
        lab's own stylesheet cannot reach out of it. The stylesheet is linked
        INTO the shadow root instead (LabCart.picker.styleTag), which is the
        one thing that does cross the boundary.
     2. The page's picker gets its per-row prices from Liquid and refreshes
        them by refetching the section (Dawn's product-info.js) on every
        change. Inside a modal there is no section to refetch. So the same
        arithmetic is done here, from the product JSON the lab already carries,
        and the rows update with no network call at all.

   THE ARITHMETIC IS A LINE FOR LINE PORT of product-variant-rows.liquid:
   the quantity guard and its suffix whitelist, the bracketed-saving split, the
   volume saving against the first row that has a quantity, the named unit
   price, the compare-at strike and the sold-out state. If that snippet
   changes, change this with it - the two are meant to print the same numbers.

   COLOURS are the Variant picker block's settings, read off the four lab
   product templates on 12 Sep 2026 (all four carry the same values):
   selected #1b1b1b on #ffffff, rows #f2f2f2 on a #e5e5e5 hairline, badge
   #1fae64. Decision 1 in the 12 Sep review is settled by his screenshot: the
   selected control IS the page's solid black.
   ========================================================================== */
(function (root) {
  'use strict';
  var LabCart = root.LabCart;
  if (!LabCart) return;
  /* HOTFIX 25 Sep 2026: P1 (i18n) calls stkT / stkFmt in this block (unitWord, the SAVE badge, the
     compare title) but they were only defined inside the line-1 block, so every picker render threw
     "ReferenceError: stkFmt" and Studio's ORDER card and foot never drew (live from 11:11 BST).
     Same definitions as line 1. */
  var stkT = root.stkT || function (k, f) { return f; };
  function stkFmt(key, fb, vars) { var s = stkT(key, fb); if (vars) { for (var vk in vars) { if (Object.prototype.hasOwnProperty.call(vars, vk)) s = s.split('{{' + vk + '}}').join(vars[vk]); } } return s; }
  /* 7 Oct 2026 (P212 audit 4): the SAVE badge in the product page's own words and number format, the key its rows
     print ('stk.stk_addons.save_badge' | t: percent: n | upcase: "SAVE 19%", "19 % SPAREN", "-19 %"). Only a page whose
     island carries that key (the Studio) changes; the other labs keep stk.lab_cart.badge_save_prefix as before. */
  function saveBadge(fig) {
    var s = stkT('stk.stk_addons.save_badge', null), m = String(fig).match(/^(\d+(?:[.,]\d+)?)\s*%$/);
    if (typeof s === 'string' && m && /\{\{\s*percent\s*\}\}/.test(s)) return s.replace(/\{\{\s*percent\s*\}\}/g, m[1]).toUpperCase();
    return stkFmt('stk.lab_cart.badge_save_prefix', 'SAVE {{percent}}', { percent: fig });
  }

  /* The block settings, measured. One place to change them. */
  var VARS = {
    '--vp-card-bg': '#ffffff',
    '--vp-card-line': '#e5e5e5',
    '--vp-card-style': 'solid',
    '--vp-card-w': '1.5px',
    '--vp-card-r': '14px',
    '--vp-card-pad': '16px',
    '--vr-sel-bg': '#1b1b1b',
    '--vr-sel-ink': '#ffffff',
    '--vr-line': '#e5e5e5',
    '--vr-row-bw': '1.5px',
    '--vr-bg': '#f2f2f2',
    '--vr-hover-bg': '#e2e2e2',
    '--vr-hover-ink': '#1a1a20',
    '--vr-badge-bg': '#1fae64',
    '--vr-badge-ink': '#eaf7f0',
    '--vr-was-ink': '#6e6e78'
  };
  /* THE DARK HALF OF THE PAIR (Thomas, 12 Sep 22:40). The picker's colours are
     emitted INLINE on .vpick, and an inline custom property cannot be beaten by
     a stylesheet rule, so dark has to be emitted too rather than overridden.
     The values are the lab's own .app.dark tokens, with one deliberate change:
     THE SELECTED ROW IS A LIGHT TILE WITH DARK INK, never black on black -
     #1b1b1b on a #1b1b1f panel was invisible. */
  var VARS_DARK = {
    '--vp-card-bg': '#232327',
    '--vp-card-line': '#3a3a41',
    '--vp-card-style': 'solid',
    '--vp-card-w': '1.5px',
    '--vp-card-r': '14px',
    '--vp-card-pad': '16px',
    '--vr-sel-bg': '#f1f1f2',
    '--vr-sel-ink': '#1a1a20',
    /* v2.9.2 (R11): variant-rows.css paints the selected row's price --vr-sel-price, white by
       default for the page's black row. The lab's dark selected row is the LIGHT tile, so the
       price, like the ink, is dark here (#1a1a20 on #f1f1f2, 16.4:1). variant-rows.css untouched. */
    '--vr-sel-price': '#1a1a20',
    '--vr-line': '#3a3a41',
    '--vr-row-bw': '1.5px',
    /* v2.6 (Thomas, 12 Sep 19:00, dark: "unselected FINISH tiles barely
       separable from the panel"): #2e2e34 on the #232327 card was 1.3:1. The
       unselected row is now #6f6f78, the least light grey that clears 3:1 on
       the card (3.04:1) and the panel (3.27:1), with white ink at 5.2:1. */
    '--vr-bg': '#6f6f78',
    '--vr-ink': '#ffffff',
    '--vr-muted': '#f4f4f6',
    '--vr-hover-bg': '#7a7a83',
    '--vr-hover-ink': '#ffffff',
    '--vr-badge-bg': '#1fae64',
    '--vr-badge-ink': '#07230f',
    '--vr-was-ink': '#f4f4f6',
    '--vr-was-ink-sel': '#55555e'
  };
  var DISPATCH_VARS_DARK = [
    '--stkd-dot:#1fab63', '--stkd-low:#ffb52d', '--stkd-ink:#f1f1f2',
    '--stkd-muted:#9a9aa2', '--stkd-bg:#232327', '--stkd-out:#ec5246',
    '--stkd-r:12px', '--stkd-bw:1.5px', '--stkd-bs:solid', '--stkd-py:11px',
    '--stkd-px:16px', '--stkd-gap-below:12px', '--stkd-minh:46px', '--stkd-bc:#3a3a41'
  ].join(';');
  var ROWS_VISIBLE = 8;   // "Rows visible" on all four templates

  /* Sapiens, through the lab's own variable where it has one. ONE WEIGHT: the
     face has no bold and synthesising it is a standing no.
     (memories: no-bold-regular-max, sapiens-glyph-substitutions) */
  var FAM = "var(--bm-display, var(--pl-display, 'Sapiens-Regular','Sapiens',sans-serif))";

  /* base.css does not cross the shadow boundary, so the handful of rules the
     picker inherits from it on the page are restated here. Nothing else: every
     colour and every measurement still comes from variant-rows.css. */
  var BASE_CSS = [
    '.labpick{display:block;container-type:inline-size;margin:0 0 14px}',
    '.labpick *{box-sizing:border-box}',
    '.labpick fieldset{border:0;margin:0;padding:0;min-width:0}',
    '.labpick legend{padding:0}',
    /* THE PICKER IS THE PAGE'S PICKER, DOWN TO THE COMPUTED TYPE.
       base.css forces 'Sapiens-Regular' onto `input[type=radio] + label`, the
       form labels and the prices, and none of that crosses a shadow boundary,
       so inside the lab the same markup fell back to the ambient Open Sans at
       15px. Diffed against the live PDP 12 Sep 18:05 and made equal: family,
       size, weight, tracking, colour. This block is the ONLY place the picker's
       type is set; the lab's own chrome keeps the lab's variable. */
    ".labpick, .labpick input[type='radio'] + label, .labpick .product-form__input label,",
    ".labpick .product-form__input span, .labpick .form__label, .labpick legend,",
    ".labpick .cgrid__txt, .labpick .vrow__name, .labpick .vrow__price,",
    ".labpick .vrow__was, .labpick .vrow__badge, .labpick .vrow__unit, .labpick .vrows__unit",
    "{font-family:'Sapiens-Regular','Sapiens',sans-serif}",
    ".labpick input[type='radio'] + label{font-size:13.5px}",
    '.labpick .form__label{display:block;margin:0 0 6px;padding:0;',
    'font-size:13px;font-weight:400;line-height:1.5;letter-spacing:.4px;color:rgba(30,30,30,.75)}',
    '.labpick a{color:inherit}',
    /* ADAPTED TO THE LAB PANEL (12 Sep 2026, 16:05). Thomas: "yes i want it to
       look like my product page but it has to be adapted for the new screen."
       The card is the panel's width, not the 535px buy column, so the padding
       comes in and the row height with it. Everything else - classes, colours,
       badges, the green per-piece line - is the page's, unchanged. */
    '.labpick--compact{--vp-card-pad:12px;--vr-row-h:50px;--vr-gap:6px}',
    '.labpick--compact .vpick-group--card{max-width:none;padding:0;border:0;background:none}',
    '.labpick--compact .vpick--in-group+.vpick--in-group{margin-top:12px}',
    /* the picker's own type is the PAGE's type: only the box gets smaller. */
    '.labpick--compact .form__label{margin-bottom:6px}',
    '.labpick--compact .vrow label{padding:9px 12px}',
    /* One row of pills, whatever the viewport. variant-rows.css drops to two
       columns below a 600px SCREEN, which is right for a phone's product page
       and wrong inside a 330px panel on a 1440px desktop: the count is what
       decides, and the count is already in --cgrid-cols. */
    '.labpick--compact .cgrid{gap:6px;grid-template-columns:repeat(var(--cgrid-cols,2),minmax(0,1fr))}',
    '.labpick--compact .cgrid--modd .cgrid__item:last-child{grid-column:auto}',
    '.labpick--compact .cgrid--orphan .cgrid__item:last-child{grid-column:1 / -1}',
    '.labpick--compact .cgrid__item label{min-height:44px;padding:9px 7px}',
    /* The struck compare-at is the first thing to go when the row runs out of
       width: it is a second price, and the row must never let the two collide.
       It stays on the label's title so it is not lost. */
    '@container (max-width: 330px){.labpick .vrow__was{display:none}}',
    '@container (max-width: 250px){.labpick .vrow__badge{display:none}}',
    /* v2.8: the page's per-piece green (#1fae64) is 2.88:1 on white and its badge ink
       #eaf7f0 is 2.61:1 on the green; inside the lab the text is #137a46 (5.38:1) and
       the badge carries dark ink (#1a1a20 on #1fae64, 6.02:1). The selected row keeps
       the page's #8fe3b5 (11.4:1 on the dark row). Dark keeps the green (5.44:1). */
    '.labpick .vrow label .vrow__unit,.labpick .vrows__unit{color:#137a46}',
    /* 23 Oct 2026: the dark ink below was written for the GREEN badge. The badge went orange on
       21 Oct and Thomas confirmed pale ink on it ("we confirmed white text on orange badges"), which
       is what variant-rows.css carries on the storefront; this override was putting black back on it
       inside every lab. Same pale as the theme: #fff4e8 on #f5841f. */
    '.labpick .vrow label .vrow__badge,.labpick .vrow input:checked + label .vrow__badge{color:#fff}',
    '.app.dark .labpick .vrow label .vrow__unit,.app.dark .labpick .vrows__unit{color:#1fae64}',
    /* THE SELECTED PILL CAN NEVER BE INVISIBLE. Its label is transparent so
       the sliding highlight shows through, and its ink is the highlight's
       opposite - which in dark is DARK ink. If the highlight is not showing
       (it is hidden until it has been measured, and a card that is drawn
       collapsed measures zero), the chip fills itself instead. The
       highlight is the first child, so the sibling combinator is exact. */
    '.labpick .cgrid__hl[hidden] ~ .cgrid__item input:checked + label{background:var(--vr-sel-bg)}',
    /* The sticky footer at the bottom of the panel: the live price, then the
       page's own Add to cart button. */
    '.labfoot{position:sticky;bottom:0;z-index:5;flex:none;display:block;',
    'padding:10px 0 2px;background:var(--panel,#fff)}',
    '.labfoot__top{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:9px}',
    '.labfoot__lbl{font-family:' + FAM + ';font-size:11px;',
    'font-weight:400;letter-spacing:.12em;text-transform:uppercase;color:var(--muted,#6a6a74)}',
    '.labfoot__price{font-family:' + FAM + ';font-weight:400;font-size:22px;',
    'letter-spacing:.02em;color:var(--ink,#1a1a20);font-variant-numeric:tabular-nums}',
    '.labfoot__was{color:#a9a9b4;text-decoration:line-through;font-size:13px;margin-right:7px}',
    '.labfoot__unit{display:flex;align-items:center;gap:5px;margin-top:3px;font-family:' + FAM + ';font-weight:400;font-size:11.5px;letter-spacing:.06em;text-transform:uppercase;color:var(--good,#1fae64)}',
    '.labfoot__unit svg{width:13px;height:13px;flex:none}',
    '.labfoot__lbl{display:block}',
    '.labfoot__status{font-size:12.5px;min-height:15px;margin-top:6px;text-align:center}',
    '.labfoot__was{font-family:' + FAM + '}'
  ].join('');

  /* The Add to cart button, from the Buy buttons block's own settings on the
     same four templates: #1b1b1b on #ffffff, 10px radius, 49px tall, no
     border, #000000 on hover, and Sapiens-Regular like every other button in
     the theme. Thomas, 12 Sep: the lab's button is the page's button. That
     settles decision 1 in the review - the flat #eff0f3 tile is the theme's
     SECONDARY action, and this is the primary one. */
  var BTN_CSS = [
    '.labbtn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;',
    "font-family:'Sapiens-Regular','Sapiens',sans-serif;font-size:14px;font-weight:400;text-transform:uppercase;",
    'letter-spacing:.06em;min-height:49px;padding:14px 18px 12px;border:0;border-radius:10px;',
    'background:#1b1b1b;color:#ffffff;cursor:pointer;transition:background .15s,transform .08s}',
    '.labbtn:hover:not(:disabled){background:#000000}',
    '.labbtn:active:not(:disabled){transform:scale(.99)}',
    '.labbtn:disabled{opacity:.45;cursor:default}',
    /* dark on dark was invisible: the button inverts with the theme */
    '.app.dark .labbtn{background:#f1f1f2;color:#1a1a20}',
    '.app.dark .labbtn:hover:not(:disabled){background:#ffffff}',
    '.app.dark .labfoot__price{color:#f1f1f2}',
    '.app.dark .labfoot__lbl{color:#9a9aa2}',
    '.app.dark .labpick .form__label{color:rgba(241,241,242,.8)}',
    '.labbtn__was{color:#a9a9b4;text-decoration:line-through;font-size:13px}'
  ].join('');

  /* The Dispatch block's settings, same four templates. */
  var DISPATCH_VARS = [
    '--stkd-dot:#1fab63', '--stkd-low:#ffb52d', '--stkd-ink:#1a1a20',
    '--stkd-muted:#6a6a74', '--stkd-bg:#ffffff', '--stkd-out:#ec5246',
    '--stkd-r:12px', '--stkd-bw:1.5px', '--stkd-bs:solid', '--stkd-py:11px',
    '--stkd-px:16px', '--stkd-gap-below:12px', '--stkd-minh:46px', '--stkd-bc:#e5e5e5'
  ].join(';');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(cents, sym) {
    /* P214 (7 Oct 2026): sym may be the page's own money formatter. The Studio passes the
       store's money format, so its rows and footer print '1 389,48 kr' like its price card,
       not 'SEK 1389.48'. A string keeps the old symbol + two decimals for any other caller. */
    if (!isFinite(Number(cents))) return '-';
    if (typeof sym === 'function') return sym(cents);
    var n = Number(cents) / 100;
    return (sym || '£') + n.toFixed(2);
  }
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  function optNames(product) {
    return (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : (o && o.name);
    });
  }
  function optsOf(v) { return v.options || [v.option1, v.option2, v.option3]; }
  function valuesOf(product, i) {
    var seen = [];
    product.variants.forEach(function (v) {
      var val = optsOf(v)[i];
      if (val != null && seen.indexOf(String(val)) < 0) seen.push(String(val));
    });
    return seen;
  }
  /* The variant this row WOULD select: this option's value, every other option
     left where the customer has it. Same rule as the snippet, which builds the
     combination and matches it against variant.title. */
  function variantFor(product, sel, names, idx, value) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], o = optsOf(v), ok = true;
      for (var n = 0; n < names.length; n++) {
        var want = (n === idx) ? value : sel[names[n]];
        if (want == null || want === '') { ok = false; break; }
        if (norm(o[n]) !== norm(want)) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* THE QUANTITY GUARD, ported whole. The leading token is a quantity only
     when it is a whole number on its own ("50", "100 Sheets") or glued to a
     count word ("50pcs"). Anything else that opens with digits is a size or a
     weight ("7.5cm x 7.5cm", "2IN/5CM"), and reading those as quantities is
     what once printed SAVE 13% on a backing-card size. */
  var QTY_SUFFIX = ',,pcs,pc,pk,pack,packs,piece,pieces,sheet,sheets,unit,units,sticker,stickers,';
  function qtyOf(label) {
    var tok = String(label).split(' ')[0] || '';
    var m = tok.match(/^(\d+)/);
    if (!m) return { qty: 0, tok: tok, glued: '' };
    var qty = parseInt(m[1], 10);
    var glued = tok.slice(m[1].length);
    var suffix = ',' + glued.toLowerCase() + ',';
    if (qty > 0 && QTY_SUFFIX.indexOf(suffix) >= 0) return { qty: qty, tok: tok, glued: glued.toLowerCase() };
    return { qty: 0, tok: tok, glued: '' };
  }

  /* "25 [SAVE 8%]", "25 (SAVE 8%)", "50 Sheets (Save 14%)" all mean the same
     thing and all get printed as one badge. Bracketed text that is NOT a
     saving is a descriptor and is kept. */
  function splitLabel(name) {
    var label = String(name), badge = '', sub = '', bits;
    if (label.indexOf('[') >= 0) {
      bits = label.split('[');
      label = bits[0].trim();
      badge = (bits[1] || '').split(']')[0].trim();
    } else if (label.indexOf('(') >= 0) {
      bits = label.split('(');
      label = bits[0].trim();
      badge = (bits[1] || '').split(')')[0].trim();
    }
    if (badge && /sav/i.test(badge)) {
      badge = saveBadge(badge.replace(/sav(ings|ing|e)/ig, '').trim());
    } else {
      sub = badge; badge = '';
    }
    return { label: label, badge: badge, sub: sub };
  }

  /* The piece is NAMED. The label's own unit word first ("48 Magnets"), then
     the product's title and type, most specific first, then "each". */
  function unitWord(label, q, product) {
    var rest = String(label).replace(q.tok, '').trim().toLowerCase().split(' ').pop();
    if (!rest && q.glued && q.glued !== 'pcs' && q.glued !== 'pc') rest = q.glued;
    var noun = '';
    if (rest) {
      noun = rest.replace('pouches', 'pouch').replace('boxes', 'box');
      if (noun.slice(-1) === 's') noun = noun.slice(0, -1);
    } else {
      var t = ((product.title || '') + ' ' + (product.type || '')).toLowerCase();
      if (t.indexOf('backing card') >= 0) noun = 'backing card';
      else if (t.indexOf('sticker sheet') >= 0) noun = 'sticker sheet';
      else if (t.indexOf('bookmark') >= 0) noun = 'bookmark';
      else if (t.indexOf('magnet') >= 0) noun = 'magnet';
      else if (t.indexOf('sticker') >= 0) noun = 'sticker';
      else if (t.indexOf('bag') >= 0) noun = 'bag';
      else if (t.indexOf('sheet') >= 0) noun = 'sheet';
    }
    /* P172 (2 Oct 2026): the nouns the shop translates (stk.studio.nouns.*, stk.backing.nouns.card) are shown in the page language, any other noun as it was */
    return noun ? stkFmt('stk.lab_cart.price_per_unit_prefix', 'per {{noun}}', { noun: (noun === 'sticker' || noun === 'magnet') ? stkT('stk.studio.nouns.' + noun, noun) : noun === 'card' ? stkT('stk.backing.nouns.card', noun) : noun }) : stkT('stk.lab_cart.unit_word_default', 'each');
  }

  var CALC_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M8 6.5h8"/><path d="M8 11h.01M12 11h.01M16 11h.01M8 15h.01M12 15h.01M16 15h.01M8 19h.01M12 19h.01M16 19h.01"/></svg>';

  /* 2 Oct 2026: Studio's band product keeps the SKU's English finish word as the VALUE (it prices
     by it); the chip shows the shop-language word from data-grid's finishLabels ("Matte" -> "Mat"). */
  var gridLbls;
  function gridLabels() {
    if (gridLbls !== undefined) return gridLbls;
    gridLbls = null;
    try {
      var h = document.querySelector('proof-lab-tool');
      if (!h) { var t = document.querySelector('template[data-pl-tpl]'); h = t && t.content ? t.content.querySelector('proof-lab-tool') : null; }
      var g = h && h.dataset && h.dataset.grid ? JSON.parse(h.dataset.grid) : null;
      gridLbls = (g && g.finishLabels) || null;
    } catch (e) { gridLbls = null; }
    return gridLbls;
  }

  function chipGrid(product, sel, names, idx, uid, group) {
    var vals = valuesOf(product, idx), n = vals.length;
    var lbls = product && product.__grid ? gridLabels() : null;
    var cols = n <= 3 ? n : (n % 3 === 0 ? 3 : 2);
    var cls = 'cgrid' + (n % 2 === 1 ? ' cgrid--modd' : '') +
      (cols === 2 && n % 2 === 1 ? ' cgrid--orphan' : '');
    var out = '<div class="' + cls + '" style="--cgrid-cols:' + cols + '" data-chip-grid role="group" aria-label="' + esc(names[idx]) + '">' +
      '<span class="cgrid__hl" data-chip-hl aria-hidden="true" hidden></span>';
    vals.forEach(function (value, i) {
      var p = splitLabel((lbls && Object.prototype.hasOwnProperty.call(lbls, value) && lbls[value]) || value);
      /* Sold out on a VALUE, not a variant: the value is unavailable when no
         combination that uses it can be bought. Same thing Liquid's
         value.available means. */
      var out_of = !product.variants.some(function (v) {
        return norm(optsOf(v)[idx]) === norm(value) && v.available !== false;
      });
      var id = uid + '-' + (idx + 1) + '-c' + i;
      out += '<div class="cgrid__item' + (out_of ? ' cgrid__item--out' : '') + '">' +
        '<input type="radio" id="' + id + '" name="' + esc(names[idx]) + '-' + (idx + 1) + (group ? '-' + esc(group) : '') + '" value="' + esc(value) + '"' +
        (norm(sel[names[idx]]) === norm(value) ? ' checked' : '') + (out_of ? ' class="disabled"' : '') +
        ' data-opt="' + esc(names[idx]) + '" data-val="' + esc(value) + '">' +
        '<label for="' + id + '">' +
        (p.sub ? '<span class="cgrid__sub">' + esc(p.sub) + '</span>' : '') +
        '<span class="cgrid__txt">' + esc(p.label) + '</span>' +
        (out_of ? '<span class="cgrid__out">' + stkT('stk.lab_cart.sold_out_badge', 'Sold out') + '</span>' : '') +
        '</label></div>';
    });
    return out + '</div>';
  }

  /* TRUE-SIZE PRICING (12 Sep 2026). When the customer has typed a size that is
     not one of the listed tiers, the price on each row is NOT the variant's: it
     is what /api/custom-quote says that exact size costs at that quantity, and
     the cart transform charges the same figure. `quoted` is {value: pence}, one
     entry per quantity row. The variant stays the tier the size fits, because
     the line still has to BE a product. */
  function rowList(product, sel, names, idx, uid, sym, quoted, group) {
    var vals = valuesOf(product, idx);

    /* Baseline for the volume saving: the first value that HAS a quantity,
       not simply the first value. A leading "Sample Sheet" parses as 0 and
       once killed every saving on the product. */
    var baseUnit = 0;
    for (var b = 0; b < vals.length; b++) {
      var bq = qtyOf(splitLabel(vals[b]).label);
      if (bq.qty > 0) {
        var bq2 = quoted && quoted[String(vals[b])];
        if (bq2 != null) { baseUnit = bq2 / bq.qty; break; }
        var bv = variantFor(product, sel, names, idx, vals[b]);
        if (bv) baseUnit = bv.price / bq.qty;
        break;
      }
    }

    var selUnit = '';
    var out = '<div class="vrows" style="--vrows-visible:' + ROWS_VISIBLE + '">';
    vals.forEach(function (value, i) {
      var p = splitLabel(value);
      var v = variantFor(product, sel, names, idx, value);
      var q = qtyOf(p.label);
      var badge = p.badge;
      var qp = quoted && quoted[String(value)];
      if (qp != null && v) v = { id: v.id, price: qp, compare_at_price: 0, available: v.available };

      if (!badge && v && baseUnit > 0 && q.qty > 0) {
        var pct = Math.round((baseUnit - v.price / q.qty) * 100 / baseUnit);
        if (pct > 0 && pct < 80) badge = saveBadge(pct + '%');
      }

      var unitLine = '';
      if (v && q.qty > 1) {
        var up = Math.round(v.price / q.qty);
        if (up >= 1) unitLine = money(up, sym) + ' / ' + unitWord(p.label, q, product);
      }

      var soldOut = !v || v.available === false;
      var checked = norm(sel[names[idx]]) === norm(value);
      if (checked && unitLine) selUnit = unitLine;

      var id = uid + '-' + (idx + 1) + '-' + i;
      out += '<div class="vrow' + (soldOut ? ' vrow--out' : '') + '">' +
        '<input type="radio" id="' + id + '" name="' + esc(names[idx]) + '-' + (idx + 1) + (group ? '-' + esc(group) : '') + '" value="' + esc(value) + '"' +
        (checked ? ' checked' : '') + (soldOut ? ' class="disabled"' : '') +
        ' data-opt="' + esc(names[idx]) + '" data-val="' + esc(value) + '">' +
        /* The compare-at also rides on the label's title, because a panel-width
           row hides the struck price rather than let two prices collide. */
        '<label for="' + id + '"' + (v && v.compare_at_price && v.compare_at_price > v.price
          ? ' title="' + stkFmt('stk.lab_cart.compare_title', 'Was {{compare_price}}, now {{price}}', { compare_price: money(v.compare_at_price, sym), price: money(v.price, sym) }) + '"' : '') +
        '><span class="vrow__left">' +
        '<span class="vrow__name">' + (p.sub ? esc(p.sub) + ' (' + esc(p.label) + ')' : esc(p.label)) + '</span>' +
        (badge ? '<span class="vrow__badge">' + esc(badge) + '</span>' : '') +
        (unitLine && !soldOut ? '<span class="vrow__unit">' + esc(unitLine) + '</span>' : '') +
        '</span><span class="vrow__right">' +
        (soldOut ? '<span class="vrow__out">' + stkT('stk.lab_cart.sold_out_badge', 'Sold out') + '</span>'
          : ((v.compare_at_price && v.compare_at_price > v.price ? '<s class="vrow__was">' + money(v.compare_at_price, sym) + '</s>' : '') +
            '<span class="vrow__price">' + money(v.price, sym) + '</span>')) +
        '</span></label></div>';
    });
    out += '</div>';
    /* On a narrow column the per-piece price leaves the rows and becomes one
       green line under the list. variant-rows.css decides which, by container
       width; both are rendered, as on the page. */
    if (selUnit) out += '<p class="vrows__unit">' + CALC_SVG + '<span>' + esc(selUnit) + '</span></p>';
    return out;
  }

  /* Which option is the row list. On the page this is a per-option setting;
     here it is the option the customer is buying BY, which is the one whose
     label carries a quantity. Measured against all four lab products 12 Sep
     2026: Custom Vinyl Stickers, Custom Sticker Sheets and Custom Magnetic
     Bookmarks all put it on Quantity, the last option. A product with no
     quantity option (the gang sheet) falls back to the last option that
     changes the price, so the price is never hidden behind a chip. */
  function rowIndex(product, names) {
    for (var i = names.length - 1; i >= 0; i--) {
      var vals = valuesOf(product, i);
      if (vals.length > 1 && vals.every(function (v) { return qtyOf(splitLabel(v).label).qty > 0; })) return i;
    }
    for (var j = names.length - 1; j >= 0; j--) {
      var vs = valuesOf(product, j);
      if (vs.length > 1) {
        var prices = {};
        product.variants.forEach(function (v) { prices[optsOf(v)[j]] = v.price; });
        var uniq = Object.keys(prices).map(function (k) { return prices[k]; });
        if (uniq.some(function (p) { return p !== uniq[0]; })) return j;
      }
    }
    return names.length - 1;
  }

  var seq = 0;

  var picker = {
    VARS: VARS,
    BASE_CSS: BASE_CSS,

    /* The stylesheet links for a shadow root. A <link> inside a shadow tree
       does apply to that tree - it is the one route the theme's own CSS has
       into the lab. Pass the asset URLs of variant-rows.css and (optionally)
       stk-dispatch.css. Call it once, at mount. */
    styleTag: function (rowsHref, dispatchHref) {
      return '<link rel="stylesheet" href="' + esc(rowsHref) + '">' +
        (dispatchHref ? '<link rel="stylesheet" href="' + esc(dispatchHref) + '">' : '') +
        '<style>' + BASE_CSS + BTN_CSS + '</style>';
    },

    /* The stock and dispatch strip that sits above the picker on the product
       page. "lead" mode, which is what all four lab product templates use, so
       no date is worked out and nothing can go stale. Out of stock is decided
       from the variant, exactly as the snippet decides it. */
    dispatch: function (variant, dark) {
      var out = !variant || variant.available === false;
      return '<div class="stkd stkd--' + (out ? 'out' : 'in') + '" style="' + (dark ? DISPATCH_VARS_DARK : DISPATCH_VARS) + '">' +
        '<span class="stkd__dot" aria-hidden="true"></span>' +
        (out
          ? '<span class="stkd__state">' + stkT('stk.lab_cart.dispatch_out_of_stock', 'Out of stock') + '</span>'
          : '<span class="stkd__state">' + stkT('stk.lab_cart.dispatch_in_stock', 'In stock') + '</span>' +
            '<span class="stkd__sep" aria-hidden="true">|</span>' +
            '<span class="stkd__label">' + stkT('stk.lab_cart.dispatch_label', 'Dispatch') + '</span>' +
            '<span class="stkd__date">' + stkT('stk.lab_cart.dispatch_estimate_default', '3 to 5 working days') + '</span>') +
        '</div>';
    },

    varStyle: function (dark) {
      var v = dark ? VARS_DARK : VARS;
      return Object.keys(v).map(function (k) { return k + ':' + v[k]; }).join(';');
    },

    /* opts: { product, sel, currency, rowIndex, compact, hide }
       `hide` is the list of option names the LAB already owns - the Proof Lab's
       own size chips are the product's Size option, and offering it twice was
       the thing Thomas called out on 12 Sep. Hidden options still live in `sel`
       and still pick the variant; they are simply not drawn twice.
       Returns the page's picker as one string. */
    render: function (opts) {
      var product = opts.product, sel = opts.sel || {}, sym = opts.currency || '£';
      var names = optNames(product);
      if (!names.length) return '';
      var hide = (opts.hide || []).map(norm);
      var ri = (opts.rowIndex == null) ? rowIndex(product, names) : opts.rowIndex;
      var uid = 'lp' + (++seq);
      var vs = picker.varStyle(opts.dark);
      var out = '<div class="labpick' + (opts.compact ? ' labpick--compact' : '') +
        '"><div class="vpick-group vpick-group--card" style="' + vs + '">';
      names.forEach(function (name, i) {
        if (hide.indexOf(norm(name)) >= 0) return;
        var isRows = (i === ri);
        out += '<div class="vpick vpick--in-group vpick--t-center" style="' + vs + '">' +
          '<fieldset class="js product-form__input product-form__input--' + (isRows ? 'rows' : 'chipgrid') + '">' +
          '<legend class="form__label">' + esc((product.__grid && product.optionLabels && product.optionLabels[name]) || name) + '</legend>' +
          (isRows ? rowList(product, sel, names, i, uid, sym, opts.quoted, opts.group) : chipGrid(product, sel, names, i, uid, opts.group)) +
          '</fieldset></div>';
      });
      return out + '</div></div>';
    },

    /* The per-piece price for the CURRENT selection, so the footer can carry the
       same green line the card shows. One number, two places it is needed: the
       card's is the page's own, the footer's is the one always on screen. */
    unitLine: function (product, sel, sym, quoted) {
      var names = optNames(product), ri = rowIndex(product, names);
      var value = sel[names[ri]];
      if (value == null) return '';
      var q = qtyOf(splitLabel(String(value)).label);
      if (!(q.qty > 1)) return '';
      var qp = quoted && quoted[String(value)];
      var v = (qp != null) ? { price: qp } : variantFor(product, sel, names, ri, value);
      if (!v) return '';
      var up = Math.round(v.price / q.qty);
      if (up < 1) return '';
      return money(up, sym || '£') + ' / ' + unitWord(splitLabel(String(value)).label, q, product);
    },

    /* The sticky footer at the foot of the lab's panel: the live price, then
       the product page's own Add to cart button, full panel width.
       spec: { variant, label, disabled, note, currency, unit } */
    footer: function (spec) {
      var v = spec.variant, sym = spec.currency || '£';
      var price = v ? ((v.compare_at_price && v.compare_at_price > v.price
        ? '<span class="labfoot__was">' + money(v.compare_at_price, sym) + '</span>' : '') +
        money(v.price, sym)) : '-';
      return '<div class="labfoot">' +
        '<div class="labfoot__top"><span class="labfoot__lbl">' + esc(spec.note || stkT('stk.lab_cart.footer_total_default', 'Total')) +
        (spec.unit ? '<span class="labfoot__unit">' + CALC_SVG + esc(spec.unit) + '</span>' : '') + '</span>' +
        '<span class="labfoot__price">' + price + '</span></div>' +
        '<button type="button" class="labbtn" id="cartAdd"' + (spec.disabled ? ' disabled' : '') + '>' +
        esc(spec.label || stkT('stk.lab_cart.add_to_cart_label_default', 'Add to cart')) + '</button>' +
        '<div class="labfoot__status" id="cartStatus"></div>' +
        '</div>';
    },

    /* Moves the one sliding highlight onto the selected chip. Ported from
       assets/variant-chips.js, which delegates from `document` and so never
       sees anything inside a shadow root. */
    placeChips: function (scope, animate) {
      if (!scope) return;
      scope.querySelectorAll('[data-chip-grid]').forEach(function (grid) {
        var checked = grid.querySelector('input:checked');
        var hl = grid.querySelector('[data-chip-hl]');
        if (!hl) return;
        if (!checked || !checked.nextElementSibling) { hl.hidden = true; return; }
        var g = grid.getBoundingClientRect(), l = checked.nextElementSibling.getBoundingClientRect();
        if (!l.width) { hl.hidden = true; return; }
        if (!animate) hl.style.transition = 'none';
        hl.style.width = l.width + 'px';
        hl.style.height = l.height + 'px';
        hl.style.transform = 'translate(' + (l.left - g.left) + 'px,' + (l.top - g.top) + 'px)';
        hl.hidden = false;
        if (!animate) { void hl.offsetWidth; hl.style.transition = ''; }
      });
    }
  };

  /* P214: tells a caller this picker accepts a money formatter as `currency`. An older lab-cart.js
     without it would print the function's source, so the Studio checks this before passing one. */
  picker.fmtMoney = true;
  LabCart.picker = picker;
})(typeof window != 'undefined' ? window : globalThis);

/* ==========================================================================
   LabCart v2 (P158, 24 Sep 2026) - ONE PROPERTY PER DESIGN, ONE ZIP EACH.

   Thomas decided the shape: a lab's cart line carries ONE visible property per
   design, numbered, and its value is ONE zip holding that design's print PNG
   and cut SVG. No preview file. Orders placed before this keep the old keys
   forever, so every reader keeps its old branch and the old buildProperties /
   checkout paths on line 1 stay exactly as they were.

   THE SCHEMA (the Uploads readers, the cart snippet and Studio read this).
   Thomas, 24 Sep 2026, on the order page mock: "i want the size to show
   underneath the artwork link. and no need at all for designs4 tool proof lab
   all that shit." So each design is two lines, in this order, and nothing else:
     "Artwork N · {qty} × {name}"  the zip URL. N = 1..4, U+00B7 and U+00D7,
                                   one space either side of each. "Artwork" in
                                   the key is what the Flow rule tagging orders
                                   "Artwork Attached" matches (key includes
                                   artwork OR upload), so no hidden marker.
     "Artwork N size"              "{W} × {H} mm, qty {qty}": the cut size in whole mm
                                   and the design's quantity. The quantity is repeated
                                   here because a Shopify cart transform can only read a
                                   line's properties by exact key, and this key is fixed
                                   while the one above holds the design's name (Custom
                                   Sticker Pricing, 24 Sep: P128 prices each design)
   The only other keys are the custom-size quote's _stk_* (the checkout cart
   transform and Dispatch read them; present only on custom-size lines).
   Dropped: Artwork Upload (N), Artwork Upload (N) Qty, _cut, _cut_N, _Preview,
   _Preview_N, Design Name, _designs, _tool, _product, _sticker_size, _sheet_size,
   _sticker_count, and this build's own first draft (Design N, _artwork_schema,
   _size_N), which no order ever carried.
   Reader regexes: /^(?:Artwork|Design) (\d+) · (\d+) × (.*)$/ and
   /^(?:Artwork|Design) (\d+) size$/

   WHY THE ZIP IS BUILT HERE, IN THE BROWSER. Uploads go straight to R2 through
   a presigned PUT, so no server ever holds the bytes to zip them, and the
   Worker is read only. STORE, no compression: the PNG is compressed already, so
   deflate would cost a phone seconds for nothing, and a STORE zip lets the
   Worker serve the PNG out of it by byte range (<zip url>?part=print is the
   cart thumbnail). This is the makeZip writer from proof-lab-order.js, moved
   here so every lab writes the same bytes. For ASCII names the output is byte
   for byte what makeZip writes (proven in lab-cart/p158/tests).
   ========================================================================== */
(function (root) {
  'use strict';
  var LabCart = root.LabCart;
  if (!LabCart) return;
  /* 2 Oct 2026: the band path's messages come from the page's i18n islands, English otherwise */
  var stkT = function (k, f) { try { return root.stkT ? root.stkT(k, f) : f; } catch (e) { return f; } };
  /* P172 (2 Oct 2026): the legacy path's and the upload's messages read the page's i18n islands too; the English
     fallback is the sentence this file carried before, so English reads exactly as it did. tk fills [name] (the
     Studio keys), tf fills {{name}} (the lab_cart keys), unitNoun is the product's own noun (LabCart.create({unit}))
     in the page language ("sticker" -> "Aufkleber"), the English word when the noun has no key. */
  function tk(k, f, vars) { var t = String(stkT(k, f)); if (vars) Object.keys(vars).forEach(function (n) { t = t.split('[' + n + ']').join(String(vars[n])); }); return t; }
  function tf(k, f, vars) { var t = String(stkT(k, f)); if (vars) Object.keys(vars).forEach(function (n) { t = t.split('{{' + n + '}}').join(String(vars[n])); }); return t; }
  var UNIT_NOUN_KEYS = { sticker: 'stk.studio.nouns.', magnet: 'stk.studio.nouns.', card: 'stk.backing.nouns.' };
  function unitNoun(unit, many) {
    var en = unit + (many ? 's' : '');
    return Object.prototype.hasOwnProperty.call(UNIT_NOUN_KEYS, unit) ? String(stkT(UNIT_NOUN_KEYS[unit] + en, en)) : en;
  }

  var SCHEMA = '2';
  var DESIGN_KEY_RE = /^(?:Artwork|Design) (\d+) \u00b7 (\d+) \u00d7 (.*)$/;
  /* Keys the builder owns. A caller's extra or hidden can never set them, so the
     designs array always wins over a stray "designs" in hidden. */
  var OWN_RE = /^_(artwork_schema|schema|designs|size_\d+)$/;
  var DROPPED_RE = /^(Artwork Upload \(\d+\)( Qty)?|_cut(_\d+)?|_Preview(_\d+)?|Design Name)$/;

  /* The name in the key. The design's own name, with the two characters the key
     is split on (· and ×), colons and control characters taken out, trimmed and
     capped at 40 characters. Counted in code points, so an emoji is never cut in
     half: a lone surrogate does not survive the trip through JSON. */
  function designName(s) {
    var t = String(s == null ? '' : s).replace(/[\u00b7\u00d7:\u0000-\u001f\u007f-\u009f]/g, ' ').replace(/\s+/g, ' ').trim();
    t = Array.from(t).slice(0, 40).join('').trim();
    return t || 'Artwork';
  }
  function designQty(q) {
    var n = Math.floor(Number(q));
    return n > 0 ? n : 0;
  }
  function designKey(n, qty, name) {
    return 'Artwork ' + n + ' \u00b7 ' + designQty(qty) + ' \u00d7 ' + designName(name);
  }
  /* size is { w, h } in mm, the figure the lab measured (Proof Lab: cutSizeMm(),
     which is exactly what /api/custom-quote is sent, Math.round to 0.1 mm).
     Whole mm here with the same Math.round. No size, no key: a reader that needs
     it falls back to _sticker_size, as it does on every old order. */
  function sizeValue(size) {
    var w = size ? Math.round(Number(size.w)) : 0, h = size ? Math.round(Number(size.h)) : 0;
    return w > 0 && h > 0 ? w + ' \u00d7 ' + h + ' mm' : '';
  }
  /* The zip's file name on R2 and on a ?dl=1 download. Slugged on purpose: the
     cart snippet's old loop treats any value containing .png/.svg/... as an
     image, so a design called "cat.png" must not put ".png" into the URL. */
  /* 2 Oct 2026: the band path's size, whole mm UP (the rule the cart transform bands by), never rounded */
  function sizeValueCeil(size) {
    var w = size ? Math.ceil(Number(size.w) - 1e-9) : 0, h = size ? Math.ceil(Number(size.h) - 1e-9) : 0;
    return w > 0 && h > 0 ? w + ' \u00d7 ' + h + ' mm' : '';
  }
  function zipFilename(n, name) {
    var slug = String(name == null ? '' : name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40).replace(/-+$/, '');
    return 'design-' + n + '-' + (slug || 'artwork') + '.zip';
  }

  function designProperties(spec) {
    spec = spec || {};
    var designs = spec.designs || [];
    if (!designs.length) throw new Error(stkT('stk.lab_cart.err_no_files', 'Nothing to send. Add a design first.'));  /* P172 (2 Oct 2026) */
    /* Custom Sticker Pricing, 24 Sep: the carrier price bands are only proven safe up to
       5000 stickers a line (past it every band from 32 sheets up can be under-priced,
       worst measured GBP 1,582.85), so a bigger line is refused rather than sold. */
    var total = designs.reduce(function (n, d) { return n + designQty(d && d.qty); }, 0);
    /* the product's own word (LabCart.create({unit}), 25 Sep 2026: Custom Magnets); stickers by default */
    var unit = String(spec.unit || 'sticker');
    if (total > 5000) throw new Error(tf('stk.lab_cart.err_over_5000', 'Orders over 5,000 {{unit}} are priced by hand. Please email hello@stickiply.com.', { unit: unitNoun(unit, true) }));  /* P172 (2 Oct 2026) */
    var p = {};
    /* 2 Oct 2026, Studio's band path ONLY (spec.bandKeys): one visible key (spec.visible, "Size" or
       "Designs", already in the shop's language) and every design as hidden keys, "_Artwork N file"
       (its zip) and "_Artwork N size" ("51 × 85 mm, qty 75", whole mm UP), plus _stk_finish. No
       "Artwork N · qty × name" key, no visible size, no other _stk_ key: checkout shows the line's
       visible keys, and the cart transform writes the order line's own. Every other lab is unchanged. */
    if (spec.bandKeys) {
      /* P172 (2 Oct 2026): tk is module-level now, the legacy path and the upload use it too */
      var upFail = stkT('stk.lab_cart.err_upload_incomplete', 'Your artwork did not finish uploading. Please try again.');
      if (designs.length > 4) throw new Error(tk('stk.studio.msg.up_to_max', 'Up to [max] designs per order. Please remove [remove].', { max: 4, remove: designs.length - 4 }));
      var vis = spec.visible || {};
      if (vis.key && vis.value != null && vis.value !== '' && String(vis.key).charAt(0) !== '_') { p[String(vis.key)] = String(vis.value); p._stk_label = String(vis.key); }   // the transform reads the label by a fixed key
      designs.forEach(function (d, i) {
        if (!d || !/^https?:\/\//i.test(String(d.url || ''))) throw new Error(upFail);
        if (designQty(d.qty) < 1) throw new Error(tk('stk.studio.msg.design_min_one', 'Each design needs at least 1 sticker.'));
        var sv = sizeValueCeil(d.size);
        if (!sv) throw new Error(upFail);
        p['_Artwork ' + (i + 1) + ' file'] = d.url;
        p['_Artwork ' + (i + 1) + ' size'] = sv + ', qty ' + designQty(d.qty);
      });
      var fin = (spec.hidden && (spec.hidden._stk_finish || spec.hidden.stk_finish)) || (spec.extra && spec.extra._stk_finish) || '';
      if (fin) p._stk_finish = String(fin);
      /* 3 Oct 2026: design 1's small preview PNG; the cart transform makes it the checkout image */
      var th = spec.hidden && (spec.hidden._stk_thumb || spec.hidden.stk_thumb);
      if (th && /^https:\/\//i.test(String(th))) p._stk_thumb = String(th);
      if (spec.note) p.Note = spec.note;
      return p;
    }
    designs.forEach(function (d, i) {
      if (!d || !/^https?:\/\//i.test(String(d.url || ''))) throw new Error(stkT('stk.lab_cart.err_upload_incomplete', 'Your artwork did not finish uploading. Please try again.'));  /* P172 (2 Oct 2026) */
      /* review 24 Sep: a design with no stickers would print "Artwork N \u00b7 0 \u00d7" on the order */
      if (designQty(d.qty) < 1) throw new Error(tf('stk.lab_cart.err_design_min_one', 'Each design needs at least 1 {{unit}}.', { unit: unitNoun(unit, false) }));  /* P172 (2 Oct 2026) */
      p[designKey(i + 1, d.qty, d.name)] = d.url;
      /* the size sits directly under its link on the order page (properties
         keep the order they are written in) */
      var s = sizeValue(d.size);
      if (s) p['Artwork ' + (i + 1) + ' size'] = s + ', qty ' + designQty(d.qty);
    });
    if (spec.note) p.Note = spec.note;
    /* Only the custom-size quote keys ride along from a caller: the checkout
       cart transform (Stickiply Custom) prices the line from _stk_* by exact
       name and Dispatch reads the true size and quantity from them. Every other
       extra or hidden key a lab passes (_tool, _product, _sticker_size, ...) is
       dropped here, so no lab can put them back on the order by accident. */
    function put(k, v) {
      if (v == null || v === '') return;
      if (!/^_stk_/.test(k)) return;
      p[k] = v;
    }
    if (spec.extra) Object.keys(spec.extra).forEach(function (k) { put(k, spec.extra[k]); });
    if (spec.hidden) Object.keys(spec.hidden).forEach(function (k) { put(k.charAt(0) === '_' ? k : '_' + k, spec.hidden[k]); });
    /* Custom Sticker Pricing, 24 Sep (P128 review, measured): a custom-size line also says
       how many designs it holds, as machine data beside the other _stk_* keys. The
       "Artwork N size" lines are ordinary properties a hand-built cart can leave out; without
       a count the checkout priced a 4-design cart as one design (GBP 20.50 against a GBP 35.50
       quote). Written only where a quote was, so a plain order carries no hidden key. */
    if (Object.keys(p).some(function (k) { return /^_stk_/.test(k); })) p._stk_designs = String(designs.length);
    return p;
  }

  /* CRC-32 from a table: the same polynomial and the same output as the bit by
     bit loop in proof-lab-order.js, about eight times less work on a 60 MB PNG. */
  var CRC_TABLE = null;
  function crc32(bytes) {
    if (!CRC_TABLE) {
      CRC_TABLE = new Uint32Array(256);
      for (var n = 0; n < 256; n++) {
        var c = n;
        for (var k = 0; k < 8; k++) c = c & 1 ? (c >>> 1) ^ 0xEDB88320 : c >>> 1;
        CRC_TABLE[n] = c >>> 0;
      }
    }
    var crc = 0xFFFFFFFF;
    for (var i = 0; i < bytes.length; i++) crc = (crc >>> 8) ^ CRC_TABLE[(crc ^ bytes[i]) & 0xFF];
    return (crc ^ 0xFFFFFFFF) >>> 0;
  }

  /* files: [{ name, bytes: Uint8Array }] -> Blob (application/zip), STORE.
     Same records as makeZip: version 20, time and date 0, no extra fields, no
     comment. One addition: a name outside ASCII sets the UTF-8 flag (bit 11), so
     Python and Windows read "café" as café. Studio decodes names as UTF-8 either
     way. The Blob copies the bytes, so the caller can drop its arrays after. */
  function zip(files) {
    var enc = new TextEncoder(), chunks = [], central = [], offset = 0;
    files.forEach(function (f) {
      var nameB = enc.encode(f.name), bytes = f.bytes, sz = bytes.length, crc = crc32(bytes);
      var flags = /[^\x00-\x7f]/.test(f.name) ? 0x0800 : 0;
      var lh = new DataView(new ArrayBuffer(30));
      lh.setUint32(0, 0x04034b50, true); lh.setUint16(4, 20, true); lh.setUint16(6, flags, true);
      lh.setUint32(14, crc, true); lh.setUint32(18, sz, true); lh.setUint32(22, sz, true);
      lh.setUint16(26, nameB.length, true);
      chunks.push(lh.buffer, nameB, bytes);
      var ch = new DataView(new ArrayBuffer(46));
      ch.setUint32(0, 0x02014b50, true); ch.setUint16(4, 20, true); ch.setUint16(6, 20, true); ch.setUint16(8, flags, true);
      ch.setUint32(16, crc, true); ch.setUint32(20, sz, true); ch.setUint32(24, sz, true);
      ch.setUint16(28, nameB.length, true); ch.setUint32(42, offset, true);
      central.push(ch.buffer, nameB);
      offset += 30 + nameB.length + sz;
    });
    var cstart = offset, csize = 0;
    central.forEach(function (c) { csize += c.byteLength; chunks.push(c); });
    var end = new DataView(new ArrayBuffer(22));
    end.setUint32(0, 0x06054b50, true);
    end.setUint16(8, files.length, true); end.setUint16(10, files.length, true);
    end.setUint32(12, csize, true); end.setUint32(16, cstart, true);
    chunks.push(end.buffer);
    return new Blob(chunks, { type: 'application/zip' });
  }

  function readBytes(b) {
    return b.arrayBuffer ? b.arrayBuffer() : new Response(b).arrayBuffer();
  }
  /* Reads a zip's central directory back out of the Blob with small slices (never
     the whole file, which on a phone would be a third copy of the PNG) and checks
     each entry's local header where the central record says it is. That is the
     same walk the Worker's ?part=print does. */
  function zipEntries(blob) {
    var tailLen = Math.min(blob.size, 22 + 0xFFFF);
    return readBytes(blob.slice(blob.size - tailLen)).then(function (buf) {
      var dv = new DataView(buf), eo = -1;
      for (var i = buf.byteLength - 22; i >= 0; i--) { if (dv.getUint32(i, true) === 0x06054b50) { eo = i; break; } }
      if (eo < 0) throw new Error('zip: no end record');
      var count = dv.getUint16(eo + 10, true), csize = dv.getUint32(eo + 12, true), cstart = dv.getUint32(eo + 16, true);
      return readBytes(blob.slice(cstart, cstart + csize)).then(function (cb) {
        var cd = new DataView(cb), dec = new TextDecoder(), out = [], off = 0;
        for (var n = 0; n < count; n++) {
          if (off + 46 > cb.byteLength || cd.getUint32(off, true) !== 0x02014b50) throw new Error('zip: bad central record ' + n);
          var nl = cd.getUint16(off + 28, true), xl = cd.getUint16(off + 30, true), kl = cd.getUint16(off + 32, true);
          out.push({ name: dec.decode(new Uint8Array(cb, off + 46, nl)), method: cd.getUint16(off + 10, true),
            crc: cd.getUint32(off + 16, true), csize: cd.getUint32(off + 20, true), size: cd.getUint32(off + 24, true),
            offset: cd.getUint32(off + 42, true), nameLen: nl });
          off += 46 + nl + xl + kl;
        }
        return Promise.all(out.map(function (e) {
          return readBytes(blob.slice(e.offset, e.offset + 30)).then(function (lb) {
            var ld = new DataView(lb);
            if (lb.byteLength < 30 || ld.getUint32(0, true) !== 0x04034b50 || ld.getUint16(26, true) !== e.nameLen || ld.getUint32(22, true) !== e.size)
              throw new Error('zip: bad local header for ' + e.name);
          });
        })).then(function () { return out; });
      });
    });
  }

  /* THE GUARD, built with the feature: a design's zip goes up only if it reads
     back as exactly the files it was made from (same names, same sizes, STORE)
     and those are ONE .png, the print file the thumbnail is served from, and ONE
     .svg, the cut line. Anything else refuses before a single byte is sent. */
  function zipDesign(files) {
    return Promise.resolve().then(function () {
      files = files || [];
      var png = 0, svg = 0;
      files.forEach(function (f) {
        if (!f || !f.name || !f.bytes || !f.bytes.length) throw new Error('zip: empty file');
        if (/\.png$/i.test(f.name)) png++;
        else if (/\.svg$/i.test(f.name)) svg++;
      });
      if (files.length !== 2 || png !== 1 || svg !== 1) throw new Error('zip: need one .png and one .svg, got ' + files.map(function (f) { return f && f.name; }).join(', '));
      var blob = zip(files);
      return zipEntries(blob).then(function (entries) {
        if (entries.length !== files.length) throw new Error('zip: ' + entries.length + ' entries for ' + files.length + ' files');
        entries.forEach(function (e, i) {
          if (e.method !== 0 || e.name !== files[i].name || e.size !== files[i].bytes.length || e.csize !== e.size)
            throw new Error('zip: entry ' + i + ' does not match ' + files[i].name);
        });
        return blob;
      });
    });
  }

  /* The upload check. A 2xx PUT already means R2 holds exactly blob.size bytes:
     the presign pins Content-Length into the signature (upload-url.mjs), so a
     short body is refused. What it cannot prove is that the public URL about to
     go on the order serves the object, so that is asked with a HEAD before
     /cart/add.js. The Worker sends no Content-Length on a HEAD today (measured 24
     Sep 2026 on a live print PNG), so the size is compared only when one comes. */
  function verifyUpload(url, size) {
    return fetch(url, { method: 'HEAD', cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('head ' + r.status);
      var len = Number(r.headers.get('content-length'));
      if (len > 0 && len !== size) throw new Error('head size ' + len + ', sent ' + size);
    });
  }

  /* One design: zip -> check -> upload -> HEAD. o = { fieldId, files, n, name }.
     Resolves to the zip's public URL. Every failure becomes the one sentence the
     customer sees, with the reason in the console. */
  function uploadDesign(upload, o) {
    o = o || {};
    var name = designName(o.name);
    var fail = function (e) {
      if (root.console) console.warn('[lab-cart] design ' + o.n + ' not sent:', e && e.message ? e.message : e);
      throw new Error(tk('stk.studio.msg.send_failed', 'We could not send \u201c[name]\u201d just now. Please try again in a moment.', { name: name }));  /* P172 (2 Oct 2026) */
    };
    if (!o.fieldId) return Promise.reject(new Error('no upload field')).catch(fail);
    /* review 24 Sep: names inside the zip become safe file names. The design name
       is the customer's own file name, and a space broke Studio's server-side
       manifest reader ((\S+) in sheet-builder-server.py) and a colon breaks
       Windows extraction. The PNG and SVG keep a common stem, so they still pair. */
    (o.files || []).forEach(function (f) {
      if (f && f.name) f.name = String(f.name).normalize('NFKD').replace(/[^\w.\-]+/g, '_');
    });
    return zipDesign(o.files).then(function (blob) {
      /* the zip holds its own copy of the bytes now, so the arrays are let go and a
         phone carries only the zip while it uploads (a caller that hands its files
         over in o and keeps no other reference frees the PNG here) */
      o.files = null;
      var size = blob.size;
      return upload(o.fieldId, blob, zipFilename(o.n, o.name)).then(function (url) {
        blob = null;
        if (!/^https?:\/\//i.test(String(url || ''))) throw new Error('no public URL');
        return verifyUpload(url, size).then(function () { return url; });
      });
    }).catch(fail);
  }

  /* checkout({ designs }) for the labs that use LabCart's own checkout. designs:
     [{ name, qty, size, fieldId?, files: [{ name, blob } | { name, bytes }] }].
     ONE design at a time, and its bytes go out of scope before the next is read,
     so a phone never holds two designs' PNGs at once. */
  function uploadDesigns(inst, designs, fieldId) {
    designs = designs || [];
    if (!designs.length) return Promise.reject(new Error(stkT('stk.lab_cart.err_no_files', 'Nothing to send. Add a design first.')));  /* P172 (2 Oct 2026) */
    var out = [];
    return designs.reduce(function (p, d, i) {
      return p.then(function () {
        return Promise.all((d.files || []).map(function (f) {
          if (f.bytes) return { name: f.name, bytes: f.bytes };
          if (!f.blob) return { name: f.name, bytes: null };
          return readBytes(f.blob).then(function (b) { return { name: f.name || f.filename, bytes: new Uint8Array(b) }; });
        })).then(function (files) {
          return inst.uploadDesign({ fieldId: d.fieldId || fieldId, files: files, n: i + 1, name: d.name });
        }).then(function (url) {
          out.push({ url: url, name: d.name, qty: d.qty, size: d.size });
        });
      });
    }, Promise.resolve()).then(function () { return out; });
  }

  LabCart.SCHEMA = SCHEMA;
  LabCart.DESIGN_KEY_RE = DESIGN_KEY_RE;
  LabCart.designName = designName;
  LabCart.designKey = designKey;
  LabCart.designProperties = designProperties;
  LabCart.zip = zip;
  LabCart.zipEntries = zipEntries;
  LabCart.zipDesign = zipDesign;
  LabCart.zipFilename = zipFilename;
  LabCart.uploadDesign = uploadDesign;
  LabCart.uploadDesigns = uploadDesigns;
})(typeof window != 'undefined' ? window : globalThis);
